import React, { useState } from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import "./AnimatedBackground"
import cn from "classnames"

const AnimatedBackground = ({ fullBg }) => {
  const [isImageShouldBlink, setImageShouldBlink] = useState(true)
  const imageData = getImage(fullBg)

  return (
    <div className="b-background__wrapper">
      <GatsbyImage
        image={imageData}
        className={cn("b-background", {
          "b-background--blink": isImageShouldBlink,
        })}
        // durationFadeIn={1000}
        style={{ position: "absolute" }}
        onLoad={() => setImageShouldBlink(false)}
        alt="Background"
      />
    </div>
  )
}

export default AnimatedBackground
